module.exports = __webpack_public_path__ + "img/bg1.2b87baaf.png";